import React from "react";
import Loading from "../Loading";

const VersionTable = ({ versions, loading, onEdit, onDelete }) => {
  return (
    <div className="overflow-x-auto">
      {loading ? (
        <div className="text-center py-6">
          <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-red-500 border-t-transparent" />
          <p className="mt-4 text-gray-600 font-medium text-sm">
            Loading versions...
          </p>
        </div>
      ) : (<>
        <table className="min-w-full border-separate text-xs md:text-sm border-spacing-0">
          <thead>
            <tr>
              <th className="border-b border-gray-200 px-2 py-2 text-left font-semibold text-gray-500">
                Platform
              </th>
              <th className="border-b border-gray-200 px-2 py-2 text-left font-semibold text-gray-500">
                Version
              </th>
              <th className="border-b border-gray-200 px-2 py-2 text-right font-semibold text-gray-500">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {versions?.map((item) => (
              <tr key={item?.id}>
                <td className="border-b border-gray-100 px-2 py-2 text-xs md:text-sm">
                  {item?.platform ?? "—"}
                </td>
                <td className="border-b border-gray-100 px-2 py-2 text-xs md:text-sm">
                  {item?.version ?? "—"}
                </td>
                <td className="border-b border-gray-100 px-2 py-2 text-right text-xs md:text-sm">
                  <div className="inline-flex gap-2">
                    <button
                      type="button"
                      onClick={() => onEdit(item)}
                      className="cursor-pointer rounded-md border border-gray-300 bg-white px-2 py-1 text-xs md:text-sm hover:bg-gray-50">
                      Edit
                    </button>
                    <button
                      type="button"
                      onClick={() => onDelete(item?.id)}
                      className="cursor-pointer rounded-md border border-red-500 bg-red-50 px-2 py-1 text-xs md:text-sm text-red-700 hover:bg-red-100">
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>)}
    </div>
  );
};

export default VersionTable;
